// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Buttons----buttons-module---container---QkPmh","blue":"src-components-Buttons----buttons-module---blue---1xFDt","gray":"src-components-Buttons----buttons-module---gray---22CUW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/buttons.module.less
// module id = 35
// module chunks = 49508567561676 70392746020482 265882835285450